<template>
  <div class="personalise">
    <div class="personalise__image">
      <picture>
        <img :src="`${addon.imageUrl}?format=webp`" :alt="addon.name" loading="lazy" />  
      </picture>
    </div>
    <div class="personalise__content">
      <h3>{{ addon.name }}</h3>
      
      <p
        v-if="showFullText || addon.description.length <= this.exceptLength"
        v-html="addon.description"
      ></p>
      <p
        v-else
        v-html="
          $options.filters.truncate(addon.description, this.exceptLength, '...')
        "
      ></p>

      <div
        v-if="addon.description.length > this.exceptLength"
        @click="toggleDescription"
        class="personalise__read"
        v-bind:class="{ 'personalise__read--less': showFullText }"
        role="button"
        tabindex="0"
        :aria-expanded="showFullText"
        :aria-label="showFullText ? data.readLessText : data.readMoreText"
      >
        {{ showFullText ? data.readLessText : data.readMoreText }}
      </div>

      <div class="personalise__footer">
        <div class="personalise__price tour-price">
          <div class="tour-price__days">
            <strong :class="{ 'tour-price__days_label': brand === Brand.Travelsphere }">{{ data.priceLabel }}</strong>
          </div>
          <div class="tour-price__value">{{ addon.price }}</div>
        </div>
        <!-- Add at checkout message for Tour page only -->
        <span class="personalise__message" v-if="!isCheckoutPage">{{
          data.addAtCheckoutText
        }}</span>
      </div>

      <!-- Book extension message for Checkout only -->
      <div class="personalise__cta" v-if="isCheckoutPage">
        <a class="btn personalise__cta-link" @click="bookExtension">{{
          checkoutData.addons.bookExtensionText
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {Brand} from './../../../brand.js';

export default {
  props: ["addon", "data", "brand"],

  data() {
    return {
      Brand,
      showFullText: false,
      exceptLength: 180,
    };
  },

  computed: {
    ...mapState("checkout", ["isCheckoutPage"]),

    checkoutData() {
      return this.$store.state.checkout.data;
    },
  },

  filters: {
    truncate(text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },

  methods: {
    toggleDescription() {
      this.showFullText = !this.showFullText;
    },

    bookExtension() {
      this.$store.commit("checkout/setTourCode", this.addon.code);
      this.$store.commit("checkout/setTourName", this.addon.name);
      this.$store.commit("checkout/setDepartureId", this.addon.departureId);
      this.$store.commit(
        "checkout/setDepartureTransportCode",
        this.addon.transportCode
      );

      this.$store.dispatch("checkout/getDepartureDetails");
      this.$store.commit("checkout/nextStep");
    },
  },
};
</script>